import React from "react";

type Props = {
  width: number,
  height: number,
  viewBox: string,
  fill: string
};

const MiniArrow = ({
  width = 9,
  height = 13,
  viewBox = "0 0 9 13",
  fill = "#A5D2E2"
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.3 7.4L4.9 10V.6H3.6V10L1.2 7.4l-1 1 4 4.2 4-4.2z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

export default MiniArrow;



// WEBPACK FOOTER //
// ./src/components/ui/MiniArrow.jsx